import { render } from "./formapago.vue?vue&type=template&id=bf0845e4"
import script from "./formapago.vue?vue&type=script&lang=js"
export * from "./formapago.vue?vue&type=script&lang=js"

import "./formapago.vue?vue&type=style&index=0&id=bf0845e4&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__